import { Icon } from '@/icon';
import type { TIcon } from '@/types';
import type React from 'react';

export function renderItemIcon({ icon }: { icon: TIcon; color: string | undefined }): React.ReactNode {
  if (!icon) return null;

  switch (icon.type) {
    case 'icon':
      return <Icon type={icon.iconType} name={icon.iconName} weight="fill" size={24} />;
    case 'emoji':
      return <span>{icon.content}</span>;
    default:
      return null;
  }
}
